import globalState from 'ui/src/state/globalState';

import Paper from '@mui/material/Paper';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './styles/css/jga_style.scss';
import './styles/css/ag_theme.scss';
import './styles/css/style.scss';
import { styled } from '@mui/material/styles';
import { FooterWrap, HeaderWrap } from 'layout';
import MainPage from './pages/MainPage';
import LoginPage from './pages/LoginPage';
import { useRecoilState } from 'recoil';
// import { useEffect } from 'react';
import { useLocation, Routes, Route, Navigate } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import env from 'config/env';
import AdminLayout from './layout/AdminLayout';
import UserListPage from './pages/admin/UserListPage';
import ServiceListPage from './pages/admin/ServiceListPage';
import LoginListPage from './pages/admin/LoginListPage';
import UserDetailPage from './pages/admin/UserDetailPage';

// const SSOURL = `${env().SSO_URL}`;

function App() {
  const [userState, setUserState] = useRecoilState(globalState);
  const { pathname, search, state } = useLocation();

  // 헤더를 표시하지 않을 페이지들
  const hideHeaderPages = ['/login'];
  const shouldShowHeader = !hideHeaderPages.includes(pathname);

  const logoutResetData = () => {
    setUserState((prevState) => ({
      ...prevState,
      UserInformation: {
        regUserId: '',
        regUserName: '',
        userId: '',
        ofcNm: '',
        CompanyID: '',
        CompanyName: '',
        ServiceID: '',
        token: '',
        ctpvNm: '',
        deptNm: '',
      },
      isLogin: false,
      isAdmin: false,
      stae: {
        CROPS: '',
        FORST: '',
        OCEAN: '',
      },
      userService: {
        CROPS: '',
        FORST: '',
        OCEAN: '',
      },
      currentPage: {
        title: '',
        url: '/',
      },
    }));
  };

  // const handleSsoLogin = () => {
  //   // SSO 로그인 페이지로 이동
  //   window.location.href = SSOURL;
  // };

  // const logoutCookie = async () => {
  //   const id = Cookies.get(env().COOKIE_NAME);

  //   if (id) {
  //     logoutResetData();
  //     try {
  //       Cookies.remove(env().COOKIE_NAME, { path: env().COOKIE_PATH, domain: env().COOKIE_DOMAIN });
  //     } catch (e) {
  //       // alert('올바른 로그인 정보가 아닙니다. 아이디 및 비밀번호를 다시 한번 확인해주세요.');
  //       return false;
  //     }
  //   }
  // };

  // useEffect(() => {
  //   // 메인페이지 접근 시 자동으로 sso 로그인 체크
  //   const param = new URLSearchParams(search);
  //   const devUserId = param.get('usrId');

  //   const autoLogin = async () => {
  //     const id = Cookies.get(env().COOKIE_NAME);

  //     if (!id) {
  //       //쿠키 없음
  //       if (devUserId) {
  //         //파라미터에 받은 값이 있을때
  //         const value = { userId: devUserId };
  //         const cookieValue = window.btoa(JSON.stringify(value));
  //         document.cookie = `${env().COOKIE_NAME}=${cookieValue}`;
  //         setUserState((prevState) => ({
  //           ...prevState,
  //           isLogin: true,
  //         }));
  //       } else {
  //         // 자동 로그인 호출
  //         handleSsoLogin();
  //       }
  //     }
  //   };

  //   autoLogin();
  // }, []);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  return (
    <div className="wrap mainWrap">
      {shouldShowHeader ? <HeaderWrap /> : null}
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              replace
              to="/main"
            />
          }
        />
        <Route
          path="/main"
          element={<MainPage />}
        />
        <Route
          path="/login"
          element={
            userState?.isLogin ? (
              <Navigate
                replace
                to="/main"
              />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/main/admin"
          element={<AdminLayout />}
        >
          <Route
            index
            element={<UserListPage />}
          />
          <Route
            path="user-list"
            element={<UserListPage />}
          />
          <Route
            path="user-list/:user_id"
            element={<UserDetailPage />}
          />
          <Route
            path="login-list"
            element={<LoginListPage />}
          />
          <Route
            path="service-list"
            element={<ServiceListPage />}
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
